import React from 'react';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';

import {
  Container,
  VehicleArea,
  AreaTitle,
  Row,
  Column,
  VideoContainer,
  AreaTitleContainer,
  AreaSubtitle,
} from './styles';

const isVimeoUrl = url => url.includes('vimeo');
// Arquivo de vídeo direto (ex.: upload S3), com ou sem query string presignada
const isDirectVideoUrl = url => /\.(mp4|webm|mov|m4v|ogg)(\?|$)/i.test(url);

export const VehicleVideos = props => {
  const { auction } = props;

  // Aceita players do Vimeo (iframe) e arquivos de vídeo diretos como .mp4/S3 (video).
  const getVideoLinks = photos =>
    photos?.filter(
      url => typeof url === 'string' && (isVimeoUrl(url) || isDirectVideoUrl(url))
    ) || [];
  const videoUrls = getVideoLinks(auction?.summary?.photos);

  // Guard: if there are no valid videos, render nothing
  if (!videoUrls || videoUrls.length === 0) return null;

  return (
    <Container>
      <VehicleArea>
        <AreaTitleContainer>
          <AreaTitle>
            <SmartDisplayIcon sx={{ marginRight: 1 }} />
            Vídeos
          </AreaTitle>
        </AreaTitleContainer>
        <Row>
          {videoUrls.map((url, index) => (
            <Column key={index} width={videoUrls.length > 1 ? `${100 / videoUrls.length}%` : '50%'}>
              <VideoContainer>
                {isVimeoUrl(url) ? (
                  <iframe
                    src={url}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    title={`Vídeo ${index + 1}`}
                  />
                ) : (
                  <video
                    src={url}
                    width="100%"
                    height="100%"
                    controls
                    playsInline
                    preload="metadata"
                    title={`Vídeo ${index + 1}`}
                  />
                )}
              </VideoContainer>
            </Column>
          ))}
        </Row>
      </VehicleArea>
    </Container>
  );
};
